
const Header = (props) => {
    return (
        <header>
            <h1>
                CV-Creator
            </h1>
        </header>
    )
}

export default Header;